export default __webpack_public_path__ + "static/media/FuelImg.4de90f12.svg";